import { jwtDecode } from 'jwt-decode'
import { devConsole } from '~/common/devConsole'

interface JWTPayload {
  EXP: number
}

export interface TokenValidationResult {
  isValid: boolean
  accessTokenExpired: boolean
  status:
    | 'both-valid'
    | 'access-expired'
    | 'missing-tokens'
    | 'invalid-tokens'
}

export const useTokenValidation = () => {
  const app = useAppStore()
  const authStore = useAuthStore()

  const validateTokens = (): TokenValidationResult => {
    // JADOO_TOKEN과 REFRESH_TOKEN 존재 여부 체크
    if (!app.user?.JADOO_TOKEN || !app.user?.REFRESH_TOKEN) {
      return {
        isValid: false,
        accessTokenExpired: false,
        status: 'missing-tokens',
      }
    }

    try {
      // JADOO_TOKEN(액세스 토큰)만 JWT 검증 (REFRESH_TOKEN은 JWT가 아님)
      const accessDecoded = jwtDecode<JWTPayload>(app.user.JADOO_TOKEN)
      const currentTime = Math.floor(Date.now() / 1000)
      const accessTokenExpired = accessDecoded.EXP < currentTime

      // 액세스 토큰 만료된 경우 (리프레시 토큰으로 갱신 필요)
      if (accessTokenExpired) {
        return {
          isValid: false,
          accessTokenExpired: true,
          status: 'access-expired',
        }
      }

      // 액세스 토큰 유효한 경우
      return {
        isValid: true,
        accessTokenExpired: false,
        status: 'both-valid',
      }
    } catch (error) {
      devConsole.error('Token validation error:', error)
      return {
        isValid: false,
        accessTokenExpired: false,
        status: 'invalid-tokens',
      }
    }
  }

  const clear = () => {
    const app = useAppStore()
    const authStore = useAuthStore()
    // 로그아웃시 쿠키 삭제
    const cookie = useCookie('user')
    cookie.value = undefined

    document.cookie = 'user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

    // 모든 저장소 초기화
    localStorage.removeItem('auth')
    localStorage.removeItem('jadoo')

    sessionStorage.clear()

    //로그아웃시 스토어 데이터 삭제
    app.$dispose()
    authStore.$dispose()
  }

  return {
    validateTokens,
    clear,
  }
}
